import type { TObject } from '@/hooks/useTranslation/types.ts'
import { useParams } from '@tanstack/react-router'
import { t } from 'i18next'
import { useMemo } from 'react'

export default function useTranslation(namespace: string = 'common'): TObject {
  const params: { locale: string } = useParams({
    strict: false,
  })

  return useMemo(
    () => ({
      t: (key: string, values?: Record<string, unknown>) =>
        t(key, { lng: params.locale, ns: namespace, ...values }),
    }),
    [params, namespace]
  )
}
